import React, { memo, useEffect, useState } from "react";
import { useStore } from "app/stores";
import { observer } from "mobx-react";
import PopupForm from "app/common/Component/Popup/PopupForm";
import {
  Button,
  Collapse,
  Grid,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import GlobitsMultiDatePicker from "app/common/form/GlobitsMultiDatePicker";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import { pagingDepartment } from "app/services/StoreRequestService";
import CommonButton from "app/common/Component/Button/CommonButton";
import { Block, Save, Search } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import TableComponent from "app/common/Component/Table/TableComponent";
import { renderBirthDate } from "app/TreatmentManagement/TreatmentListAll/TreatmentListAllData";
import {
  getDateTime,
  getDepartmentsUser,
  isAdmin,
} from "app/common/LocalFunction";
import { SERVICE_REQUEST_STATUS } from "app/common/LocalConst";
import { useFormikContext } from "formik";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import FilterListIcon from "@material-ui/icons/FilterList";
import GlobitsSelectInput from "app/common/form/GlobitsSelectInput";
import useDefaultDepartment from "app/common/hooks/useDefaultDepartment";

function TreatmentUpdateMultiplePopup({
  open,
  handleClose,
  initialValues,
  handleSubmit,
  handleChangeFormSearchTreatment,
  handleAfterSubmit,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const [openFilterFilter, setOpenFilter] = useState(false);
  const isAdmins = isAdmin();
  const department = useDefaultDepartment();
  const departmentsUser = getDepartmentsUser();

  useEffect(() => {
    const defaultSearch = {
      departmentIds: isAdmins
        ? department
          ? [department]
          : []
        : departmentsUser || [],
    };
    handleChangeFormSearchTreatment(defaultSearch);
  }, []);

  return (
    <PopupForm
      size="lg"
      title="Cập nhật nhiều điều trị"
      open={open}
      handleClose={handleClose}
      formik={{
        initialValues: initialValues,
        onSubmit: handleChangeFormSearchTreatment,
      }}
      action={({ isSubmitting, values }) => {
        return (
          <div className="flex-center gap-1">
            <CommonButton
              disabled={isSubmitting}
              // type="submit"
              className="btn-primary"
              onClick={async () => {
                let data = await handleSubmit();
                if (handleAfterSubmit && data) {
                  handleAfterSubmit();
                }
              }}
            >
              {!isMobile && <Save className="mr-2 " />}
              Cập nhật
            </CommonButton>

            <CommonButton className="btn-gray" onClick={handleClose}>
              <Block className="mr-2" /> Đóng
            </CommonButton>
          </div>
        );
      }}
    >
      {({ setFieldValue, values }) => {
        return (
          <>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6} md={3}>
                <GlobitsMultiDatePicker
                  label="Thời gian chỉ định từ - đến ngày"
                  name="orderDateFrom"
                  range
                  rangeHover
                  fromField="orderDateFrom"
                  toField="orderDateTo"
                  // format={"DD/MM/YYYY"}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <GlobitsSelectInput
                  name={"healthCareSv"}
                  label={"Trạng thái"}
                  options={SERVICE_REQUEST_STATUS}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={7} className="flex flex-end">
                <CommonButton
                  className="btn-filter mr-2"
                  color={"white"}
                  onClick={() => setOpenFilter((prev) => !prev)}
                >
                  <FilterListIcon color="red" />
                  {!isMobile && "Bộ lọc nâng cao"}
                </CommonButton>
                <Button className="btn-primary" type="submit">
                  <Search />
                  Tìm kiếm
                </Button>
              </Grid>

              <Grid item xs={12} sm={12}>
                <Collapse in={openFilterFilter}>
                  <Grid container spacing={1} className="cards-body">
                    <Grid item xs={12} sm={6} md={3}>
                      <GlobitsMultiDatePicker
                        label="Thời gian thực hiện từ - đến ngày"
                        name="performDateFrom"
                        range
                        rangeHover
                        fromField="performDateFrom"
                        toField="performDateTo"
                        // format={"DD/MM/YYYY"}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <GlobitsPagingAutocomplete
                        name={"departmentIds"}
                        label={"Cơ sở"}
                        api={pagingDepartment}
                        multiple
                      />
                    </Grid>
                  </Grid>
                </Collapse>
              </Grid>

              <Grid item xs={12}>
                <TreatmentTable />
              </Grid>
            </Grid>
          </>
        );
      }}
    </PopupForm>
  );
}

const TreatmentTable = observer(() => {
  const {
    pageTreatment,
    handleChangeFormSearchTreatment,
    setSelectedTreatmentList,
    selectedTreatmentList,
  } = useStore().treatmentManagementStore.treatmentUpdateImageAndTourStore;
  const { t } = useTranslation();
  const { values } = useFormikContext();

  return (
    <TableComponent
      className=""
      showOrdinalNumbers
      titleNodata={t("noData")}
      selectType={"multi"}
      resetSelectedRows
      selectedRows={selectedTreatmentList}
      handleChangeSelectedRows={(selectedItems) => {
        setSelectedTreatmentList(selectedItems);
      }}
      showMoreButton
      name="TreatmentListPatientData"
      data={pageTreatment?.content || []}
      minWidth={"720px"}
      columns={[
        {
          field: "service.name",
          title: t("Dịch vụ"),
          render: (rowData) => {
            return (
              <>
                <div className="pl-1 pr-1">
                  <div>
                    <span className="service-code">
                      {rowData?.service?.code}
                    </span>{" "}
                    <span className="service-name">
                      {rowData?.service?.tradeName || rowData?.service?.name}
                    </span>
                  </div>
                  {rowData?.times && (
                    <span className="font-size-12">
                      {`Lần điều trị: ${rowData?.times || 0} ${
                        rowData?.unLimited
                          ? "(Không giới hạn)"
                          : "| " + (rowData?.totalTreatmentTimes || 0)
                      }`}
                    </span>
                  )}
                </div>
              </>
            );
          },
        },

        {
          field: "age",
          title: t("Ngày sinh"),
          render: (rowData) => renderBirthDate(rowData?.encounter?.patient),
        },

        // {
        //   field: "encounter.patient.phoneNumber",
        //   title: t("Số điện thoại"),
        // },

        {
          field: "department.name",
          title: t("Cơ sở"),
        },

        {
          field: "room.name",
          title: t("Phòng"),
        },

        {
          field: "assigner.staffName",
          title: t("Người chỉ định"),
        },

        {
          field: "encounterParticipants",
          title: t("Nhân viên tham gia"),
          render: (row) => {
            const names = row?.encounterParticipants
              ?.map((ep) => {
                const staffName = ep?.staff?.staffName;
                const positionName = ep?.position?.name;
                const isMains = ep?.isMain;
                if (staffName && positionName) {
                  return `${positionName} - ${staffName} - ${
                    isMains ? " ⭐" : ""
                  }`;
                }
                return staffName || positionName || "";
              })
              ?.filter(Boolean)
              ?.join(", ");
            return names || "";
          },
        },

        {
          field: "orderDate",
          title: t("Thời gian chỉ định"),
          render: (val) => getDateTime(val?.orderDate),
        },

        {
          field: "receptionTime",
          title: t("Thời gian tiếp nhận"),
          render: (val) => getDateTime(val?.receptionTime),
        },

        {
          field: "performDate",
          title: t("Thời gian thực hiện"),
          render: (val) => getDateTime(val?.performDate),
        },

        {
          field: "itemStatus",
          title: t("Trạng thái"),
          render: (rowData) => {
            const status = rowData?.itemStatus;

            return (
              <span>
                {SERVICE_REQUEST_STATUS?.find((item) => item.value === status)
                  ?.name || t("Chưa xác định")}
              </span>
            );
          },
        },
        {
          field: "hasImg",
          title: t("Đã up ảnh"),
          align: "center",
          render: (row) => (row?.hasImg ? "✔️" : "❌"),
        },
        {
          field: "note",
          title: t("Ghi chú"),
        },
      ].filter(Boolean)}
      dataPagination={{
        pageIndex: values.pageIndex,
        pageSize: values.pageSize,
        totalElements: pageTreatment.totalElements,
        totalPages: pageTreatment.totalPages,
        setPageIndex: (pageIndex) =>
          handleChangeFormSearchTreatment({ pageIndex }),
        setPageSize: (pageSize) =>
          handleChangeFormSearchTreatment({ pageSize }),
      }}
    />
  );
});

export default memo(observer(TreatmentUpdateMultiplePopup));
